import React from "react";
import moment from "moment-timezone";
import pluralize from "pluralize";
import { bool, node, number } from "prop-types";

import { useOHData } from "../../redux/hooks/openHousesHooks";
import { useUIBehavior, useUIData } from "../../redux/hooks/uiHooks";
import * as S from "./styled";

const OpenHousesListWrapper = props => {
  const { expandMyRecentOH, expandMyUpcomingOH } = useUIBehavior();
  const {
    myRecentOpenHousesExpanded,
    myUpcomingOpenHousesExpanded
  } = useUIData();
  const { OHDate } = useOHData();
  const buttonIsHidden = props.isUpcoming
    ? myUpcomingOpenHousesExpanded
    : myRecentOpenHousesExpanded;
  const openHousesNumber =
    props.openHousesNumber > 0 ? props.openHousesNumber : "";

  const OHDateDaysAgo = moment()
    .tz("America/New_York")
    .diff(moment(OHDate).tz("America/New_York"), "days");

  const OHDateIsYesterday = OHDateDaysAgo === 1;
  const getOpenHouseCategory = () => {
    if (props.isUpcoming) return "Upcoming";
    return OHDateIsYesterday ? "Yesterday's" : "Past";
  };

  return (
    <S.Wrapper>
      <S.Title isUpcoming={props.isUpcoming}>
        {getOpenHouseCategory()} open houses
      </S.Title>
      <S.SubTitle>
        {props.isUpcoming
          ? `View the latest on your ${openHousesNumber} open ${pluralize(
              "house",
              openHousesNumber
            )}.`
          : "Did you attend these open houses? We appreciate your feedback!"}
      </S.SubTitle>
      <S.ListWrapper>
        {props.children}
        {openHousesNumber <= 0 && (
          <S.EmptyStateWrapper>
            <S.CalendarCheckIcon />
            <S.EmptyTitle>
              No {props.isUpcoming ? "upcoming" : "recent"} open houses
            </S.EmptyTitle>
          </S.EmptyStateWrapper>
        )}
      </S.ListWrapper>
      {props.nextNumberOpenHouses > 0 && !buttonIsHidden && (
        <S.ActionWrapper>
          <S.LoadMoreButton
            aria-label={`Show ${props.nextNumberOpenHouses} more`}
            onClick={() =>
              props.isUpcoming ? expandMyUpcomingOH() : expandMyRecentOH()
            }
          >
            Show {props.nextNumberOpenHouses} more
          </S.LoadMoreButton>
        </S.ActionWrapper>
      )}
    </S.Wrapper>
  );
};

OpenHousesListWrapper.propTypes = {
  children: node,
  isUpcoming: bool,
  nextNumberOpenHouses: number,
  openHousesNumber: number
};

OpenHousesListWrapper.defaultProps = {
  children: null,
  isUpcoming: true,
  nextNumberOpenHouses: 5,
  openHousesNumber: 5
};

export default OpenHousesListWrapper;
